import React from 'react';
import styled from 'styled-components';

const ErrorContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  padding: 20px;
  text-align: center;
  background: var(--light-gray);
`;

const ErrorTitle = styled.h1`
  font-size: 2rem;
  color: var(--secondary-color);
  margin-bottom: 20px;
`;

const ErrorMessage = styled.p`
  font-size: 1.1rem;
  color: var(--secondary-color);
  margin-bottom: 30px;
  max-width: 600px;
`;

const ErrorButton = styled.button`
  background: var(--primary-color);
  color: var(--white-color);
  padding: 12px 24px;
  border-radius: var(--border-radius);
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: var(--transition);
  
  &:hover {
    background: #e67e00;
  }
`;

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    // Bir sonraki render'da hata durumunu güncelle
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // Hata detaylarını logla
    console.error('ErrorBoundary caught an error:', error, errorInfo);
    this.setState({
      error: error,
      errorInfo: errorInfo
    });
  }

  handleReload = () => {
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      return (
        <ErrorContainer>
          <ErrorTitle>Bir Hata Oluştu</ErrorTitle>
          <ErrorMessage>
            Üzgünüz, beklenmeyen bir hata oluştu. Lütfen sayfayı yenileyin veya daha sonra tekrar deneyin.
          </ErrorMessage>
          {process.env.NODE_ENV === 'development' && this.state.error && (
            <details style={{ marginBottom: '20px', textAlign: 'left' }}>
              <summary>Hata Detayları (Geliştirici Modu)</summary>
              <pre style={{ 
                background: '#f5f5f5', 
                padding: '10px', 
                borderRadius: '4px',
                fontSize: '12px',
                overflow: 'auto',
                maxWidth: '100%'
              }}>
                {this.state.error && this.state.error.toString()}
                <br />
                {this.state.errorInfo.componentStack}
              </pre>
            </details>
          )}
          <ErrorButton onClick={this.handleReload}>
            Sayfayı Yenile
          </ErrorButton>
        </ErrorContainer>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
